module.exports = "/_next/static/images/TicketGuardian-7b71b83c8e57915b054c17ad0ae25c73.png";